import React from 'react';
import {
    imageContainerStyles,
    ImageShadowCaption,
} from '../ImageShadowCaption';
import HeroImageStyles from './HeroImage.module.scss';
import { DotsSVG } from './Svgs/Dots';

export interface HeroImageProps {
    imageSource: string;
    altText: string;
    htmlAttribution?: string;
}

export const HeroImage = ({
    imageSource,
    altText,
    htmlAttribution,
}: HeroImageProps) => {
    return (
        <div className={HeroImageStyles.heroImage} data-testid="hero-image">
            <div
                className={`${HeroImageStyles.imageContainer} ${imageContainerStyles.imageContainer}`}
            >
                <div className={HeroImageStyles.dotsContainer}>
                    <DotsSVG />
                </div>
                <img
                    className={`${HeroImageStyles.image} ${imageContainerStyles.image}`}
                    src={imageSource}
                    alt={altText}
                />

                {htmlAttribution ? (
                    <ImageShadowCaption
                        captionContainerClass={
                            HeroImageStyles.imageCaptionBorderRadius
                        }
                    >
                        <>
                            Photo From{' '}
                            <span
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: htmlAttribution,
                                }}
                            ></span>
                        </>
                    </ImageShadowCaption>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};
